export default {
  no_mobile_app: 'Ingen mobilapp konfigureret',
  mobile_app_not_live: 'Mobilappen er ikke live',
};
